export default __webpack_public_path__ + "static/media/port1.73680246.png";